<div class="font-bold mb-3" style="font-size: 1.2rem">{{ 'menu.notifications' | translate}}</div>

<p-card>
  <p-toast />
  <p-toolbar styleClass="mb-4 gap-2">
    <ng-template pTemplate="left">
      <p-button severity="success" [label]="'settings.newNotif' | translate" icon="pi pi-plus" class="mr-2"
        (onClick)="openAddNewNotif()" />
    </ng-template>

  </p-toolbar>

  <p-table #dt [value]="notifications" [rows]="10" [paginator]="true" [globalFilterFields]="['title', 'message']"
    [tableStyle]="{ 'min-width': '75rem' }"
    [loading]="loading" [(selection)]="selectedNotifications" [rowHover]="true" dataKey="id"
    [currentPageReportTemplate]="'table.currentPageReportTemplate' | translate" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <h5 class="m-0">{{'settings.manageNotif' | translate}}</h5>
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input pInputText type="text" (input)="onFilterChange($event, dt)"
            [placeholder]="'primeng.search' | translate" />
        </p-iconfield>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <!--  <th style="width: 4rem">
        
            </th> -->
        <th pSortableColumn="title" style="min-width:10rem">
          {{'table.title' | translate}} <p-sortIcon field="title" />
        </th>

        <th pSortableColumn="message" style="min-width:15rem ; max-width: 20rem;">
          {{'table.message' | translate}} <p-sortIcon field="message" />
        </th>
        <th pSortableColumn="type" style="min-width:8rem">
          {{'table.type' | translate}} <p-sortIcon field="type" />
        </th>

        <th pSortableColumn="status" style="min-width:8rem">
          {{'table.status' | translate}} <p-sortIcon field="status" />
        </th>
        <th pSortableColumn="endDate" style="min-width:10rem">
          {{'table.endDate' | translate}} <p-sortIcon field="endDate" />
        </th>
        <th pSortableColumn="status" style="min-width:10rem">
          {{'settings.users' | translate}} <p-sortIcon field="status" />
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-notif>
      <tr>
        <!--       <td>
                <p-tableCheckbox [value]="notif" />
            </td> -->
        <td style="max-width: 20rem;">
          {{ notif.title }}
        </td>

        <td style="max-width: 15rem;">
          @if(notif.message.length > 100) {

          <div class="truncated" [tp]="tpl" [tpPlacement]="'bottom'" [tpPopperWidth]="'400px'">{{ notif.message}}</div>
          <ng-template #tpl let-hide>
            <div class="flex align-items-center text-justify p-2" style="line-height: 13px; font-size: 11px">
              {{ notif.message }}
            </div>
          </ng-template>
          } @else {
          <div>{{ notif.message }}</div>
          }
        </td>
        <td>
          {{ notif.type }}
        </td>

        <td>
          <p-tag [value]="notif.status | translate" [severity]="getSeverity(notif.status)" />
        </td>
        <td>
          {{notif.endDate}}
        </td>
        <td style="max-width: 15rem;">
          @if(notif.userEmails.length > 1) {

          <div class="truncated" [tp]="tpl" [tpPlacement]="'bottom'" [tpPopperWidth]="'400px'">{{ notif.userEmails}}
          </div>
          <ng-template #tpl let-hide>
            <div class="flex align-items-center text-justify p-2" style="line-height: 13px; font-size: 11px">
              <ul>
                @for(email of notif.userEmails; track $index){
                  <li>{{email}}</li>
                }
              </ul>
            </div>
          </ng-template>
          } @else {
          <div>{{ notif.userEmails }}</div>
          }
        </td>
        <td>
          <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [outlined]="true" severity="success"
            (onClick)="editNotification(notif)" />
          <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
            (onClick)="deleteNotification(notif)" />
        </td>
      </tr>
    </ng-template>
    <!--     <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
            In total there are {{ products ? products.length : 0 }} products.
        </div>
    </ng-template> -->
  </p-table>


  <p-dialog [(visible)]="notifDialog" [style]="{ width: '550px' }" [header]="'settings.notifDetails' | translate"
    [modal]="true" styleClass="p-fluid" [closable]="false">
    <ng-template pTemplate="content">
      <div class="field ml-3">
        <label for="title"> {{'table.title' | translate}}</label>
        <input type="text" pInputText id="title" [(ngModel)]="notif.title" required autofocus />
        <small class="p-error" *ngIf="submitted && !notif.title">
          Title is required.
        </small>
      </div>
      <div class="field ml-3">
        <label for="message"> {{'table.message' | translate}}</label>
        <textarea id="message" pTextarea [(ngModel)]="notif.message" required rows="3" cols="20">
                    </textarea>
      </div>

      <div class="field ml-3">
        <label for="status">{{'table.status' | translate}}</label>
        <p-select [(ngModel)]="notif.status" inputId="status" [options]="statuses">
          <ng-template pTemplate="selectedItem">
            <p-tag [value]="notif.status | translate" [severity]="getSeverity(notif.status)" />
          </ng-template>
          <ng-template let-option pTemplate="item">
            <p-tag [value]="option | translate" [severity]="getSeverity(option)" />
          </ng-template>
        </p-select>
      </div>

      <div class="field ml-3">
        <label class="mb-3" for="type">{{'table.type' | translate}}</label>
        <div class="formgrid grid">
          @for(type of notifTypes; track $index) {
          <div class="field-radiobutton col-6">
            <p-radioButton [id]="type.toLowerCase()" [name]="type.toLowerCase()" [value]="type"
              [(ngModel)]="notif.type" />
            <label [for]="type.toLowerCase()">{{type}}</label>
          </div>
          }

        </div>
      </div>
      <div class="field ml-3">
        <label for="endDate">{{'table.endDate' | translate}}</label>
        <p-datepicker
          appendTo="body"
          [(ngModel)]="notif.endDate" 
          [showIcon]="true" 
          [showOnFocus]="false" 
          [readonlyInput]="true"
          dateFormat="dd/mm/yy"
          [placeholder]="'filters.enterEndDate' | translate"
          inputId="endDate"
          [showTime]="true"
          [showSeconds]="true"
          inputStyleClass="w-full"
          [minDate]="minDate" />
      </div>
      @if(isNewNotification) {
      <p-stepper [value]="activeStep" [linear]="true" orientation="vertical">
        <p-step-item [value]="1">
          <p-step>{{ 'notification.sendNotif' | translate }}</p-step>
          <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
              @for(option of options; track $index) {
                <div class="field-radiobutton col-8 mt-3">
                  <p-radioButton [id]="option.id" [name]="option.id" [value]="option.value" [(ngModel)]="selectedOption" />
                  <label [for]="option.id">{{ option.label | translate }}</label>
                </div>
              }
              @if(selectedOption == 'user' || selectedOption == 'shopUsers') {
                <div class="flex py-1">
                  <p-button [label]="'buttons.next' | translate" (onClick)="activateCallback(2)" />
                </div>
              }
            </ng-template>
          </p-step-panel>
        </p-step-item>

        <p-step-item [value]="2">
          <p-step>{{ 'notification.chooseUserShop' | translate }}</p-step>
          <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
              <div class="mt-3">
                @if(selectedOption == 'shopUsers') {
                  <div class="mt-1 mb-3">
                    <label class="font-bold">{{ 'notification.selectShop' | translate }}</label>
                  </div>
                  <div>
                    <app-custom-shop-selector (shopSelected)="updateSelectedShop($event)"></app-custom-shop-selector>
                  </div>
                } @else if(selectedOption == 'user') {
                  <div class="mt-1 mb-3">
                    <label class="font-bold">{{ 'notification.selectUser' | translate }}</label>
                  </div>
                  <div>
                    <p-listbox
                      [options]="aggregators"
                      [(ngModel)]="selectedAggregator"
                      optionLabel="name"
                      [style]="{ width: '23rem' }"
                      [multiple]="false"
                      [filter]="true"
                      [filterPlaceHolder]="'settings.searchShop' | translate"
                      [metaKeySelection]="false"
                      [listStyle]="{ 'max-height': '220px' }"
                      [showToggleAll]="false"
                    />
                  </div>
                }
              </div>
              <div class="flex py-4 gap-2">
                <p-button [label]="'buttons.back' | translate" severity="secondary" (onClick)="activateCallback(1)" />
              </div>
            </ng-template>
          </p-step-panel>
        </p-step-item>
      </p-stepper>
      <!--      <div class="formgrid grid">
        <div class="field col">
          <label for="price">Price</label>
          <p-inputNumber id="price" [(ngModel)]="notif.price" mode="currency" currency="USD" locale="en-US" />
        </div>
        <div class="field col">
          <label for="quantity">Quantity</label>
          <p-inputNumber id="quantity" [(ngModel)]="notif.quantity" />
        </div>
      </div>  -->
      }

    </ng-template>

    <ng-template pTemplate="footer">
      <p-button [label]="'buttons.cancel' | translate" icon="pi pi-times" [text]="true" (onClick)="hideDialog()" />
      <p-button [label]="'buttons.validate' | translate" icon="pi pi-check" [disabled]="!notif.title ||
         !notif.message ||
          !notif.type ||
           !notif.status ||
            (isNewNotification && (!selectedOption || (selectedOption == 'shopUsers' && !selectedShopCode) || (selectedOption == 'user' && !selectedAggregator)))" [text]="true"
        (click)="CreateUpdateNotification()" />
    </ng-template>
  </p-dialog>

  <p-confirmDialog [style]="{ width: '450px' }" />
</p-card>